import { createContext, useContext } from 'react';
import { usePDI } from '../hooks/usePDI';

const PDIContext = createContext(null);

export const PDIProvider = ({ children }) => {
  const pdi = usePDI();
  
  return (
    <PDIContext.Provider value={pdi}>
      {children}
    </PDIContext.Provider>
  );
};

export const usePDIContext = () => {
  const context = useContext(PDIContext);
  if (!context) {
    throw new Error('usePDIContext must be used within a PDIProvider');
  }
  return context;
};

export default PDIContext;
